import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import Pagination from 'react-js-pagination';

class Paginate extends Component {
    handlePageChange = (pageNo) => {
        const { auth, fetch } = this.props;
        fetch(auth.token,{page: pageNo});
    }

    render(){
        const { meta: { currentPage, total, perPage } } = this.props;
        return (
            <Row>
                <Col xs="12" md="6">
                    <span>Showing { perPage*currentPage - perPage +1 } to { total > currentPage*perPage ? currentPage*perPage: total } of { total } records. </span>
                </Col>
                <Col xs="12" md="6" className="mt-2 d-xs-block d-md-flex mt-md-0 justify-content-md-end">
                    <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={perPage}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    innerClass="pagination"
                    itemClass="page-item"
                    linkClass="page-link"
                    activeClass="active"
                    onChange={this.handlePageChange}
                    />
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps)(Paginate);




// WEBPACK FOOTER //
// ./src/Components/App/Layout/Paginate.js